export default "__VITE_ASSET__Dewz2cWy__"